import PropTypes from 'prop-types';

import { useState } from 'react';
import profile from 'src/store/profile';
import api from 'src/utils/api';
// @mui
import { Stack, TextField, Snackbar, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';

// ----------------------------------------------------------------------

CreateMessage.propTypes = {
  student: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sgroup_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    course_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  success: PropTypes.func.isRequired,
  type: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  offlink: PropTypes.bool,
  lessonid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  groupid: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default function CreateMessage({ student, success, type, offlink, lessonid, groupid }) {
  const [text, setText] = useState('');
  const [link, setLink] = useState('');
  const [error, setError] = useState('');
  const [errorLink, setErrorLink] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  const handleClick = () => {
    if (link === '' || (link.startsWith('http') && link.length > 10))
      if (text !== '')
        api.post('message-api/create', {
          text,
          link,
          type,
          teacher_id: profile.data.id,
          student_id: type === 2 ? 1 : student.id,
          group_id: type === 2 ? groupid : student.sgroup_id,
          lesson_id: lessonid,
          course_id: type === 2 ? 0 : student.course_id,
          studio_id: profile.data.studio_id,
        })
          .then((result) => {
            if (result.id) {
              success();
              setText('');
              setLink('');
            } else if (result.status === 'error') setError(result.message);
          })
          .catch((err) => {
            api.logError('create message failed', err);
            setError('true');
            setSnackbar({ open: true, message: err?.message || 'Помилка при відправленні повідомлення', severity: 'error' });
          });
      else setError('true');
    else setErrorLink(true);
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          multiline
          rows={4}
          name="text"
          label="Введіть текст"
          value={text}
          error={Boolean(error)}
          onChange={(event) => {
            setText(event.target.value);
          }}
        />

        {!offlink ? (
          <TextField
            name="link"
            label="Посилання http://"
            value={link}
            error={errorLink}
            onChange={(event) => {
              setLink(event.target.value);
            }}
          />
        ) : null}

        <LoadingButton type="submit" variant="contained" onClick={handleClick}>
          Надіслати
        </LoadingButton>
      </Stack>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert onClose={() => setSnackbar(s => ({ ...s, open: false }))} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
